<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn class="mr-3" depressed color="secondary" small v-on="on">{{$t('newAttribute')}}</v-btn>
    </template>
    <v-card>
      <v-tabs fixed-tabs>
        <v-tab left ripple>{{$t("newAttribute")}}</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  required
                  outlined
                  dense
                  :rules="rules()"
                  counter="512"
                  v-model="name"
                  v-bind:label="$t('name')"
                ></v-text-field>
                <v-select
                 :menu-props="{ bottom: true, offsetY: true }"
                  outlined
                  dense
                  :items="attributeClasses"
                  v-model="classId"
                  item-text="name"
                  item-value="id"
                  v-bind:label="$t('class')"
                  return-masked-value
                ></v-select>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">{{$t('close')}}</v-btn>
        <v-btn color="primary" text @click="add">{{$t('add')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import uuid from "uuid";
export default {
  name: "addProductSolution",
  props: ["attributeClasses", "index"],
  data: () => ({
    show: false,
    dialog: false,
    name: null,
    classId: null,
    valid: true,
    // attributeClasses: [],
    search: null
  }),
  methods: {
    close() {
      this.dialog = false;
    },
     rules(property = this.$t("name")) {
      let rules = [
        v => !!v || `${property} ${this.$t("required")}`,
        v => (v && v.length <= 512) || ""
      ];
      return rules;
    },
    add() {
      if (this.$refs.form.validate() && this.classId) {
        const qRLogAttribute = {
          id: uuid.v4(),
          code: this.name,
          qrLogAttributeClassId: this.classId,
          visible: true,
          //add next index
          index: this.index
        };
        this.$http
          .saveAttribute(qRLogAttribute)
          .then(res => {
            this.$emit("add", res.data);
            this.name = "";
            this.$noty.success('<i class="fas fa-check"></i>');
            this.close()
          })
          .catch(err => {
            this.$noty.error(err);
            console.log(err);
          });
      }
    }
  },
  watch: {}
};
</script>




// WEBPACK FOOTER //
// src/components/pages/Settings/AddAttribute.vue